
  import { Component, Vue } from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';

  @Component({
    components: {
      AppDialog
    }
  })
  export default class ChangePasswordPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'profile', dialogName: 'changePasswordPopup' };
    password = {
      new: '',
      old: '',
      newConfirm: ''
    };

    get formModel() { return this.password; }

    formRules = {
      old: [{ required: true, message: 'Укажите старый пароль', trigger: 'blur' }],
      new: [{ required: true, message: 'Укажите новый пароль', trigger: 'blur' }],
      newConfirm: [{
        validator: (rule, value, callback) => value === this.password.new ? callback() : callback(new Error('Пароли не совпали')),
        message: 'Повторите новый пароль',
        trigger: 'blur'
      }],
    };

    onConfirmChangePassword() {
      this.$refs.formPasswords.validate((valid) => {

        if (valid) {
          this.$store.dispatch('profile/changePassword', this.password);
        } else {
          return false;
        }
      });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
